function toggleSummaryBullets() {
    var bullets = document.querySelector('.ProductMeta__SummaryBullets'),
        button = document.querySelector('.ProductMeta__ReadMore');

    if (!bullets || !button) {
        return;
    }

    if (bullets.querySelectorAll('li').length > 3) {
        var moreText = button.innerText,
            lessText = button.dataset.lessText;

        button.addEventListener('click', function() {
            this.setAttribute('aria-expanded', this.getAttribute('aria-expanded') === 'true' ? 'false' : 'true' );
            this.innerText = this.getAttribute('aria-expanded') === 'true' ? lessText : moreText;
            bullets.classList.toggle('ProductMeta__SummaryBullets--all');
        });
    } else {
        button.style.display = 'none';
    }
}

function toggleVariantThumbnails() {
    document.addEventListener('variant:changed', function(event) {
        var variant = event.detail.variant,
            variantSku = variant.sku.toLowerCase(),
            targetOption = document.querySelector('.Product').dataset.changeImageOption;
            if (targetOption in variant) {
                var colorName = variant[targetOption].replace(/\s+/g, '').replace('/', '').toLowerCase(),
                thumbs = document.querySelectorAll('.Product__SlideshowNav .Product__SlideshowNavImage'),
                hasThumb = document.querySelectorAll('.Product__SlideshowNav .Product__SlideshowNavImage[data-color="'+ colorName +'"]').length,
                dots = document.querySelectorAll('.Product__SlideshowMobileNav .dot');

            if (hasThumb) {
                thumbs.forEach( function(thumb) {
                    if (colorName === thumb.dataset.color.toLowerCase() 
                        || variantSku === thumb.dataset.imageVariant.toLowerCase()) {
                        thumb.classList.remove('hidden-tablet-and-up');
                    } else {
                        thumb.classList.add('hidden-tablet-and-up');
                    }
                });
                toggleVariantDots(colorName, variantSku);
            } else {
                thumbs.forEach( function(thumb) {
                    thumb.classList.remove('hidden-tablet-and-up');
                });
                dots.forEach( function(dot) {
                    dot.classList.remove('hidden-phone','hidden-tablet', 'hidden-lap');
                })
            }
        }

    });
}

function toggleVariantDots(selectedColor, variantSku) {
    const productSlideshow = Flickity.data('.Product__Slideshow');
    if (productSlideshow) {
        var thumbs = document.querySelectorAll('.Product__SlideshowNavImage');
        var dots = document.querySelectorAll('.Product__SlideshowMobileNav .dot');
        thumbs.forEach( function(thumb,i) {
            dots[i].dataset.color = thumb.dataset.color;
            dots[i].dataset.imageVariant = thumb.dataset.imageVariant.toLowerCase();
            if(selectedColor === thumb.dataset.imageVariant.toLowerCase() 
                || variantSku === thumb.dataset.imageVariant.toLowerCase()) {
                dots[i].classList.remove('hidden-phone','hidden-tablet', 'hidden-lap');
            } else {
                dots[i].classList.add('hidden-phone','hidden-tablet', 'hidden-lap');
            }
        });
    }
}

function initPDPBullets() {
    var bulets_wrapper = document.querySelectorAll('.summary-bullets');
    var bulets = document.querySelectorAll('.summary-bullets ul li');
    if(bulets.length && bulets_wrapper.length){
        var x = document.createElement("button");
        x.setAttribute("data-status", 0);
        var t = document.createTextNode("Read More");    // Create a text node
        x.appendChild(t);
        bulets_wrapper[0].appendChild(x);
        x.addEventListener('click', function() {
            let status =  x.getAttribute("data-status");

            if(parseInt(status)===0){
                x.textContent = "Read Less";
                for( const bulet of bulets ) {
                    bulet.style.display = "list-item";

                }
                x.setAttribute("data-status", 1);
            } else {
                x.textContent = "Read More";
                x.setAttribute("data-status", 0);
                let p = 1;
                for( const bulet of bulets ) {
                    if(p>3){
                        bulet.style.display = "none";
                    }
                    p++;
                }
            }

        });
    }
    let i = 1;
    for( const bulet of bulets ) {
        if(i>3){
            bulet.style.display = "none";
        }

        i++;
    }
}

(function () {
  const theToggle = document.getElementById('the_toggle');
  const theText = document.getElementById('the_text');

  if (!theToggle || !theText) {
    return;
  }

  // If the text is clamped, display the read more button
  function initOveriewViewMore() {
    var clientHeight = theText.clientHeight;
    var scrollHeight = theText.scrollHeight;
    var isClamped = scrollHeight > clientHeight;
    
    if (isClamped) { 
        theToggle.style.display = 'block';
    } else {
        theToggle.style.display = 'none';
    }
  }

  function handleClick(event) {
    event.preventDefault();
    if (theText.classList.contains("clamped_text")) {
      theToggle.textContent = "Read Less";
      theText.classList.remove("clamped_text");
      theText.classList.add("expanded_text");
    } else {
      theToggle.textContent = "Read More";
      theText.classList.remove("expanded_text");
      theText.classList.add("clamped_text");
    }
  }

  initOveriewViewMore();
  theToggle.addEventListener('click', handleClick);
  
  window.addEventListener('resize', initOveriewViewMore);
})();

(function () {
  const theToggle = document.getElementById('compare_toggle');
  const toggleText = document.getElementById('compare_toggle_text');
  const theIcon = document.getElementById('compare-arrow');
  const theText = document.getElementById('compare_table');

  function handleClick(event) {
    event.preventDefault();
    if (theText.classList.contains("clamped_text")) {
      toggleText.innerHTML = "Read Less";
      theText.classList.remove("clamped_text");
      theText.classList.add("expanded_text");
      theIcon.style.transform = 'rotate(180deg)';
    } else {
      toggleText.innerHTML = "Read More";
      theText.classList.remove("expanded_text");
      theText.classList.add("clamped_text");
      theIcon.style.transform = 'rotate(0deg)';
    }
  }

  if (theToggle) {
    theToggle.addEventListener('click', handleClick);
  }
})();

(function () {
  const theToggle = document.querySelector('#included_toggle');
  const theIcon = document.querySelector('#included-arrow');

  function handleClick(event) {
    event.preventDefault();
    if (theToggle.classList.contains("included-closed")) {
      theToggle.classList.remove("included-closed");
      theToggle.classList.add("included-open");
      if (theIcon) {
        theIcon.style.transform = 'rotate(180deg)';
      }
    } else {
      theToggle.classList.remove("included-open");
      theToggle.classList.add("included-closed");
      if (theIcon) {
        theIcon.style.transform = 'rotate(0deg)';
      }
    }
  }

  if (theToggle) {
    theToggle.addEventListener('click', handleClick);
  }
})();

document.addEventListener('DOMContentLoaded', function() {
    toggleSummaryBullets();
    toggleVariantThumbnails();
    initPDPBullets();


});
